import { STATUS } from '@features/General'
import { createSlice } from '@reduxjs/toolkit'
import { AnyCnameRecord } from 'dns'

export interface IAuthSliderState {
    status: string
    data: []
    email: string
    password?: string
    cognitoUser: AnyCnameRecord
    isActivation: boolean
    redirectUrl: string
    errors: any
}

const initialState: IAuthSliderState = {
    status: STATUS.IDLE,
    data: [],
    email: '',
    password: '',
    cognitoUser: null,
    isActivation: false,
    redirectUrl: '',
    errors: null
}

const authSlider = createSlice({
    name: 'ui/auth-slider',
    initialState,
    reducers: {
        onRequest(state) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        },
        setLoggedInInfo(state, action) {
            const objectkeys = Object.keys(action.payload)
            for (const item of objectkeys) {
                state[item] = action.payload[item]
            }
        }
    }
})

export const authSliderActions = authSlider.actions
export default authSlider.reducer

// https://redux-toolkit.js.org/api/createSlice
